import React from "react";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import ReactDOM from "react-dom";

import App from "./App";
import "./index.css";

declare global {
  interface Window {
    gtag: any;
  }
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN?.toString(),
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT?.toString(),
  integrations: [new BrowserTracing(), new Sentry.Replay()],

  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.render(<App />, document.getElementById("root"));
